import { useQuery } from '@tanstack/react-query'
import type { AgentOtcGetHistoryParams } from '../api'
import { agentOtcGetHistoryOptions } from './agent-otc.options'

export const useAgentOtcGetHistory = (params: AgentOtcGetHistoryParams) => {
  return useQuery(agentOtcGetHistoryOptions(params))
}
